import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
const DefaultSwitch = withStyles((theme) => ({
  root: {
    width: 60,
    height: 32,
    padding: 0,
    '& .MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.grey.veryLight,
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.common.white,
    },
    '& .MuiSwitch-thumb, & .Mui-check ': {
      backgroundColor: theme.palette.common.white,
    },
    '& .Mui-disabled .MuiSwitch-thumb': {
      backgroundColor: theme.palette.grey.veryLight,
    },
    '& .MuiSwitch-track': {
      backgroundColor: theme.palette.grey.veryLight,
    },
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(26px)',
      '& + $track': {
        backgroundColor: theme.palette.active.main,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.active.main,
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
    backgroundColor: '#fff',
  },
  track: {
    borderRadius: 32 / 2,
    opacity: 1,
    backgroundColor: theme.palette.grey.veryLight,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
})

export default DefaultSwitch
